var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeFreeLightMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 4C0.600098 1.79086 2.39096 0 4.6001 0H22.6001C24.8092 0 26.6001 1.79086 26.6001 4V12C26.6001 14.2091 24.8092 16 22.6001 16H4.6001C2.39096 16 0.600098 14.2091 0.600098 12V4Z",
    fill: "#534C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4462 8.48242V9.47852H9.96963V12.3887H8.73916V9.47852H5.31143V8.48242H13.4462ZM6.26846 7.52539V3.94141H12.4696V7.52539H6.26846ZM7.49893 6.54883H11.2294V4.92773H7.49893V6.54883ZM21.8985 10.3867V11.4121H13.7638V10.3867H15.8438V9.0293H14.7013V6.04102H19.7306V5.08398H14.6915V4.08789H20.961V7.03711H15.9513V8.02344H21.1661V9.0293H19.9063V10.3867H21.8985ZM17.0548 10.3867H18.6856V9.0293H17.0548V10.3867Z",
    fill: "#D4D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeFreeLightMode);
export default __webpack_public_path__ + "static/media/badge_free-LightMode.8743ea528d2aaa207e61a038af6f55a4.svg";
export { ForwardRef as ReactComponent };